module.exports = __webpack_public_path__ + "img/2.e0d67d87.png";